export enum PermissionType {
    None = 0,
    Read = 1,
    Write = 2,
}

export interface SecurityObjectPermission {
    codigoObjetoSeguridad: string;
    rutaVirtual: string | null;
    tipoPermiso: PermissionType; // viene como byte del back
}


export type SecurityObjectDictionary = Record<string, SecurityObjectPermission>;














